// extracted by css-extract-rspack-plugin
export default {"cls1":"PodcastLibraryCarouselAd-cls1_UN_","cls2":"PodcastLibraryCarouselAd-cls2_y7B PodcastLibraryCarouselAd-cls1_UN_"};